import React from 'react';

const StepContent = ({ 
step,
children,
className = '' 
}) => {
const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;

return (
<div className={`step-content ${isMobile ? 'step-content-mobile' : ''} ${className}`}>

<div className="step-body">
{children}
</div>
</div>
);
};

export default StepContent;